<template>
    <div class="fSize">
        <!--<p>报告详情页面</p>-->
        <!--<van-cell :value="'体检用户：'+listQuery.xm"/>
        <van-cell :value="'体检编号：'+listQuery.ywlsh"/>-->
        <!--<van-cell :value="'总检日期：'+listQuery.zjrq"/>-->
        <van-row class="header">
            <van-col class="item blackB" span="5">体检用户:</van-col>
            <van-col class="item" span="4">{{listQuery.xm}}</van-col>
            <van-col class="item blackB" span="5">体检编号:</van-col>
            <van-col class="item" span="10">{{listQuery.ywlsh}}</van-col>
            <van-col class="item blackB" span="5">总检医生:</van-col>
            <van-col class="item" span="4">{{listQuery.zjysmc}}</van-col>
            <van-col class="item blackB" span="5">总检日期:</van-col>
            <van-col class="item" span="10">{{listQuery.zjrq}}</van-col>
        </van-row>
        <van-tabs v-model="status" line-width="1rem" type="card" color="#1989fa">
            <van-tab title="体检汇总" title-style="font-size:0.28rem;">
                <van-cell-group v-for="(item,index) in detail.tjSummary" :title="index">
                    <van-cell v-if="typeof item === 'object'" class="font28">
                        <van-row v-for="(i,index) in item">
                            <van-col span="8">{{index}}</van-col>
                            <van-col span="16">{{i}}</van-col>
                        </van-row>
                    </van-cell>
                    <van-cell v-else class="font28">
                        <van-row>
                            <van-col span="24">{{item}}</van-col>
                        </van-row>
                    </van-cell>
                </van-cell-group>
            </van-tab>
            <!--<van-tab title="检查明细" title-style="font-size:0.28rem;">
                <van-cell value-class="newStyle">
                    <van-row>
                        <van-col span="9">体检项目名称</van-col>
                        <van-col span="7">体检结果</van-col>
                        <van-col span="8">结果参考范围</van-col>
                    </van-row>
                </van-cell>
                <van-cell-group v-for="(item,index) in detail.reportDetail" :title="index">
                    <van-cell>
                        <van-row v-for="i in item">
                            <van-col span="9">{{i.tjxmmc}}</van-col>
                            <van-col span="7">{{(i.jg == null || i.jg === "NULL" || i.jg === "null" ? "-&#45;&#45;" :
                                i.jg)+(i.dw == null || i.dw === "NULL" || i.dw === "null" ? "" : (" "+i.dw))}}
                            </van-col>
                            <van-col span="8">{{i.fwtxt == null || i.fwtxt === "NULL" || i.fwtxt === "null" ? "-&#45;&#45;" :
                                i.fwtxt}}
                            </van-col>
                        </van-row>
                        <van-divider content-position="right">审核医生:{{item[0].shysmc == null || item[0].shysmc === "NULL"
                            || item[0].shysmc === "null" ? "~~~" :
                            item[0].shysmc}}
                        </van-divider>
                    </van-cell>
                </van-cell-group>
            </van-tab>-->
            <van-tab title="诊断结论" title-style="font-size:0.28rem;">
                <van-cell-group v-for="(item,index) in detail.diagnosisRes" :title="index">
                    <van-cell class="font28">
                        <van-row v-for="i in item">
                            <van-col span="24">{{i.jbmc}}</van-col>
                        </van-row>
                    </van-cell>
                </van-cell-group>
            </van-tab>
            <van-tab title="体检建议" title-style="font-size:0.28rem;">
                <div v-for="(item,index) in detail.proposal">
                    <van-cell-group v-if="index==='jy' || index ==='kepu'" :title="index==='jy' ? '建议' : '科普'">
                        <van-cell class="font28">
                            <template #default>
                                <span v-html="replaces(detail.proposal ? replaces(index==='jy' ? detail.proposal.jy : detail.proposal.kepu) : '')"></span>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </div>
            </van-tab>
        </van-tabs>
        <van-empty v-show="emptyShow" :description="emptyMsg"/>
    </div>
</template>
<script>
    import {Tab, Tabs, List, Cell, CellGroup, Empty, Col, Row, Divider} from "vant";
    import {getReport} from '@/api/report';

    export default {
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [List.name]: List,
            [Empty.name]: Empty,
            [Col.name]: Col,
            [Row.name]: Row,
            [Divider.name]: Divider
        },
        data() {
            return {
                status: 0,
                detail: {},
                listQuery: {},
                emptyMsg: "暂无信息",
                emptyShow: true
            }
        },
        created() {
            const that = this;
            //接收页面传递的参数
            //that.listQuery = sessionStorage.getItem("reportDetail") != null ? JSON.parse(sessionStorage.getItem("reportDetail")) : {};
            that.listQuery = that.$route.query.reportDetail ? JSON.parse(that.$route.query.reportDetail) : that.listQuery;
            //查询详情
            that.getDetail();
        },
        methods: {
            //获取报详情
            getDetail() {
                const that = this;
                that.detail = {};
                getReport({ywlsh: that.listQuery.ywlsh, openId: sessionStorage.getItem("openid")}).then(resp => {
                    if (resp.code === 200) {
                        that.emptyShow = false;
                        that.detail = resp.data;
                    } else {
                        that.emptyShow = true;
                        that.emptyMsg = resp.msg;
                    }
                }).catch(err => {
                    console.log(err);
                })
            },
            //替换字符
            replaces(s) {
                let str_arr = s.trim().split("\n");
                let result = "";
                for (let i = 0; i < str_arr.length; i++) {
                    if (i !== 0 && str_arr[i].indexOf("*") === 0) {
                        result += "<hr />";
                    }
                    result += str_arr[i].indexOf("*") === 0 ? "<span style='font-weight:700;'>" + str_arr[i] + "</span>" : "\r\r" + str_arr[i];
                    result += "<br/>";
                }
                return result;
            }
        }
    }
</script>
<style scoped lang="scss">
    .newStyle {
        font-weight: 700;
    }

    .header {
        padding: 0.2rem 0.32rem;
        background: white;

        .item {
            font-size: 0.28rem;
            line-height: 0.68rem;
            text-align: left;
        }

        .blackB {
            font-weight: 700;
        }
    }
</style>
